import { Component } from '@angular/core';
import { PaymentService } from '../../../pay/services/payment.service';
import { Router } from '@angular/router';
import { CartStoreService } from '../../services/cart.service';

@Component({
standalone: false,
  selector: 'app-cart-button',
  templateUrl: './cart-button.component.html',
  styleUrls: ['./cart-button.component.scss'],
})
export class CartButtonComponent {
  public counter: number;
  public paymentId: string;

  constructor(public cartService: CartStoreService, public paymentService: PaymentService, private router: Router) {
    this.cartService.state$.subscribe(value => {
      if (value) {
        this.counter = value.counter;
        this.paymentId = value.paymentId;
      }
    });
  }

  goToCart() {
    if (this.paymentId) {
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      this.router.onSameUrlNavigation = 'reload';
      this.router.navigateByUrl(`liabilities/pay/${this.paymentId}`, { replaceUrl: true });
    } else {
      this.router.navigateByUrl(`liabilities/pay`);
    }
  }
}
